import * as R from 'ramda'
import i18n from '../i18n'
import { formatUnit } from './units'

const numberLocale = () => (i18n.language === 'en' ? 'en-GB' : 'da-DK')

export function formatNumber(
  number,
  maximumFractionDigits,
  minimumFractionDigits
) {
  if (Number.isFinite(number)) {
    return number.toLocaleString(numberLocale(), {
      maximumFractionDigits,
      minimumFractionDigits,
    })
  } else {
    return '—'
  }
}

export function formatHouseholdNumber(number, virtual = false) {
  if (!number) {
    return ''
  } else if (virtual) {
    return `S${number}`
  } else {
    return number.toString()
  }
}

export function formatQuantity(quantity = '') {
  const [value, unit] = R.pipe(R.defaultTo(''), R.split(' '))(quantity)
  const fractionDigitCount = R.pipe(
    R.split('.'),
    R.nth(1),
    R.defaultTo(''),
    R.length
  )(value)

  const formattedValue = formatNumber(
    value ? Number(value) : undefined,
    fractionDigitCount,
    fractionDigitCount
  )
  const formattedUnit = formatUnit((unit ?? '').trim())

  return R.trim(formattedValue + formattedUnit)
}
